import React from 'react';



export default class Indicator extends React.Component {


    render() {
        const {formattedId,indicatorId,text, checked, updateAnswer} = this.props
        return <div className="ms-Grid-col ms-lg2" >
            <input type="radio" name={formattedId} id={indicatorId}
                    checked={checked}
                    onClick={updateAnswer}         
                />
            <label htmlFor={indicatorId}>{text}</label>
            </div>
    }

}

/*            <div key={i} className="ms-Grid-col ms-lg3" >
            <input type="radio" name={levelId} value={id}
                id={selectedActivity.id + id + i}  
                defaultChecked={isIndicatorChecked(selectedAssessment.answers,selectedActivity.id,levelId,id)}
                onClick={updateAnswer}                    
            />
            <label htmlFor={id}>{indicator.text}</label>
        </div>
*/


// WEBPACK FOOTER //
// ./src/activities/components/Indicator.js